class VwGnlKurumgrupDTO {
    id: number = 0;
    adi?: string = "";
    icmaltarihyontem?: number = 1;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
}
export default VwGnlKurumgrupDTO;